<template>
  <div class="phone-validate">
    <van-field size="small"></van-field>
  </div>
</template>

<script>
export default {
  name: 'PhoneValidate'
}
</script>

<style scoped></style>
